import ConsentProvider from "./ConsentProvider";
export const NETLIFE_CONSENT_SETTINGS_EVENT = "netlife-consent-settings:open";
export function isNetlifeConsentSettingsEvent(event) {
    return event.type === NETLIFE_CONSENT_SETTINGS_EVENT;
}
class NetlifeConsentProvider extends ConsentProvider {
    constructor(onChangeCallback) {
        super();
        this.allowTracking = window.ntlfConsentAllowTracking;
        this.onChangeCallback = onChangeCallback;
        // Trigger the current value on load to notify the providers
        this.getAllowTracking = this.getAllowTracking.bind(this);
    }
    getAllowTracking() {
        return this.allowTracking;
    }
    handleConsentPush() {
        return false;
    }
    openSettings() {
        window.dispatchEvent(new CustomEvent(NETLIFE_CONSENT_SETTINGS_EVENT, { detail: { provider: this } }));
        return true;
    }
    setAllowTracking(value) {
        this.allowTracking = value;
        this.onChangeCallback(this.allowTracking);
        writeNetlifeConsentCookie(value);
    }
}
export function writeNetlifeConsentCookie(allowTracking) {
    const date = new Date();
    // EU seems to be ok with expiration times up to 13 months.
    //   Until determined otherwise it is set to 1 year here.
    date.setTime(date.getTime() + 31536000000);
    const cookieValue = allowTracking ? "1" : "0";
    document.cookie =
        "cookieConsent=" +
            cookieValue +
            ";" +
            "expires=" +
            date.toUTCString() +
            ";path=/;";
}
export function hasNetlifeConsentCookie() {
    return document.cookie
        .split(";")
        .some((cookie) => cookie.trim().startsWith("cookieConsent="));
}
export default NetlifeConsentProvider;
